import { TPoints } from '@src/common/types/points';

export const getOutputs = (key: string, outputs: TPoints['outputs']): boolean =>
  outputs.some((item) => item.key === key);
